import { CommonModule, NgIf, NgStyle } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DialogConfirmDeleteComponent } from 'src/app/core/dialog/dialog-confirm-parker-delete/dialog-confirm-delete.component';
import { ErrorDialogStopComponent } from 'src/app/core/dialog/error-dialog-stop/error-dialog-stop.component';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataBroadcastService } from 'src/app/core/services/broadcast/data-broadcast.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ClonerService } from 'src/app/core/services/helper/cloner.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { AceStates } from 'src/app/shared/data/states';
import { IAdditionalVehicles, IParkerProfileDetail, IState } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-parkers-v2-additional-vehicles',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatCardModule,
    NgIf,
    CommonModule,
    MatButtonModule,
    IgxGridModule,
  ],
  templateUrl: './parkers-v2-additional-vehicles.component.html',
  styleUrl: './parkers-v2-additional-vehicles.component.scss',
})
export class ParkersV2AdditionalVehiclesComponent implements OnInit {
  @Input() parkerDetail: IParkerProfileDetail;
  parker: IParkerProfileDetail = {} as IParkerProfileDetail;
  additionalVehicles: IAdditionalVehicles[] = [];
  vehicleForm: FormGroup;
  vehicleEditForm: FormGroup;
  vehicleSaveMode: boolean = false;
  additionalVehicleSaveMode: boolean = false;
  additionalVehicleStates: IState[] = [];

  gridFontSize: number = 12;
  currentlyActiveRow: number = -1;
  currentVehicleEditIndex: number = -1;
  updateVehicleMode: boolean = false;
  additionalVehicleId: number = 0;
  isProcessing: boolean = false;

  _messageService = inject(MessageDialogService);
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private router: Router,
    private dataService: DataService,
    private parkerStateService: ParkerStateService,
    private dataBroadcastService: DataBroadcastService,
    private authService: AuthService,
    private clonerService: ClonerService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    console.log('additional vehicles component init');
    //this.parkerDetail = this.parkerStateService.getParkerDetail();

    this.initAdditionalVehicleStateList();

    this.initVehicleForm();

    this.initVehicleEditForm();

    this.getAllAdditionalVehiclesForParker(this.parkerDetail.parkerId);
  }

  onSubmitUpdateVehicle(): void {
    let vehicleData: IAdditionalVehicles = {} as IAdditionalVehicles;

    vehicleData.parkerId = this.parkerDetail.parkerId;
    vehicleData.vehicleId = this.additionalVehicleId;
    vehicleData.vehicleLicense = this.vehicleEditForm.get('additionalEditVehicleLicensePlate')!.value;
    vehicleData.vehicleMake = this.vehicleEditForm.get('additionalEditVehicleMake')!.value;
    vehicleData.vehicleModel = this.vehicleEditForm.get('additionalEditVehicleModel')!.value;
    vehicleData.vehicleColor = this.vehicleEditForm.get('additionalEditVehicleColor')!.value;
    vehicleData.vehicleState = this.vehicleEditForm.get('additionalEditVehicleState')!.value;
    vehicleData.userName = this._appGeneralState.userName;
    vehicleData.emailAddress = this.parkerDetail.emailAddress;
    vehicleData.firstName = this.parkerDetail.firstName;
    vehicleData.lastName = this.parkerDetail.lastName;

    this.updateAdditionalVehicle(vehicleData);
  }

  updateAdditionalVehicle(vehicleData: IAdditionalVehicles) {
    let status: boolean;
    this.isProcessing = true;
    this.dataService.updateAdditionalVehicleForParker(vehicleData).subscribe(
      (res) => {
        status = res;
      },
      (err: any) => {
        this.isProcessing = false;
        this._messageService.snackBarTopCenterTimed(
          'Error occurred during License Plate sync with spACE. Please try again.',
          5000,
        );
      },
      () => {
        this.isProcessing = false;
        this._messageService.snackBarTopCenterTimed('The Vehicle has been successfully updated.', 5000);

        let ii: number = 0;

        for (ii = 0; ii < this.additionalVehicles.length; ii++) {
          if (vehicleData.vehicleId === this.additionalVehicles[ii].vehicleId) {
            this.additionalVehicles[ii].vehicleModel = vehicleData.vehicleModel;
            this.additionalVehicles[ii].userName = vehicleData.userName;
            this.additionalVehicles[ii].vehicleMake = vehicleData.vehicleMake;
            this.additionalVehicles[ii].vehicleColor = vehicleData.vehicleColor;
            this.additionalVehicles[ii].vehicleState = vehicleData.vehicleState;
            this.additionalVehicles[ii].vehicleLicense = vehicleData.vehicleLicense;
          }
        }

        this.currentVehicleEditIndex = -1;
        this.additionalVehicleSaveMode = false;
        this.updateVehicleMode = false;

        this.initVehicleEditForm();
        this.getAllAdditionalVehiclesForParker(this.parkerDetail.parkerId);
      },
    );
  }

  public onKeyDown(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') keyDown.stopPropagation();
  }

  onEnableCancelVehicleEditMode(): void {
    this.initVehicleEditForm();
    this.updateVehicleMode = false;
    this.currentVehicleEditIndex = -1;
    this.additionalVehicleSaveMode = false;
  }

  onEnableVehicleEditMode(vehicleId: number): void {
    this.additionalVehicleSaveMode = true;

    this.updateVehicleMode = true;

    const additionalVehicle = this.additionalVehicles.find((vehicle) => vehicle.vehicleId == vehicleId);
    this.additionalVehicleId = additionalVehicle.vehicleId;

    this.initVehicleEditForm();

    this.vehicleEditForm.patchValue({
      additionalEditVehicleLicensePlate: additionalVehicle.vehicleLicense,
      additionalEditVehicleMake: additionalVehicle.vehicleMake,
      additionalEditVehicleModel: additionalVehicle.vehicleModel,
      additionalEditVehicleColor: additionalVehicle.vehicleColor,
      additionalEditVehicleState: additionalVehicle.vehicleState,
    });
  }

  initVehicleEditForm(): void {
    try {
      this.vehicleEditForm = new FormGroup({
        additionalEditVehicleLicensePlate: new FormControl('', [Validators.required]),
        additionalEditVehicleMake: new FormControl('', []),
        additionalEditVehicleModel: new FormControl('', []),
        additionalEditVehicleColor: new FormControl('', []),
        additionalEditVehicleState: new FormControl('', []),
      });
    } catch (err) {
      console.error('Error on init vehicle edit form ' + JSON.stringify(err));
    }
  }

  initAdditionalVehicleStateList(): void {
    let stateList = new AceStates();

    this.additionalVehicleStates = stateList.AceUSStateList();
  }

  initVehicleForm(): void {
    try {
      this.vehicleForm = new FormGroup({
        additionalVehicleLicensePlate: new FormControl('', [Validators.required]),
        additionalVehicleMake: new FormControl('', []),
        additionalVehicleModel: new FormControl('', []),
        additionalVehicleColor: new FormControl('', []),
        additionalVehicleState: new FormControl('', []),
        vehicleEnforcementSubLot: new FormControl('', [
          // Up to 10 alphanumeric sub lots (1-6 chars each), separated by commas.
          // Spaces (ASCII 32) are allowed around the commas and at the start/end, e.g. "555A, 65778B".
          Validators.pattern(/^ *[A-Za-z0-9]{1,6}( *, *[A-Za-z0-9]{1,6}){0,9} *$/),
        ]),
      });
    } catch (err) {
      console.error('Error on init vehicle edit form ' + JSON.stringify(err));
    }
  }

  onResetAdditionalVehicleData(): void {
    this.vehicleForm.patchValue({
      additionalVehicleLicensePlate: '',
      additionalVehicleMake: '',
      additionalVehicleModel: '',
      additionalVehicleColor: '',
      additionalVehicleState: '',
    });
  }

  onSubmitAddNewVehicle(): void {
    let newVehicle: IAdditionalVehicles = {} as IAdditionalVehicles;

    newVehicle.parkerId = this.parkerDetail.parkerId;
    newVehicle.vehicleId = 0;
    newVehicle.vehicleLicense = this.vehicleForm.get('additionalVehicleLicensePlate')!.value;
    newVehicle.vehicleMake = this.vehicleForm.get('additionalVehicleMake')!.value;
    newVehicle.vehicleModel = this.vehicleForm.get('additionalVehicleModel')!.value;
    newVehicle.vehicleColor = this.vehicleForm.get('additionalVehicleColor')!.value;
    newVehicle.vehicleState = this.vehicleForm.get('additionalVehicleState')!.value;
    newVehicle.vehicleEnforcementSubLot = this.vehicleForm.get('vehicleEnforcementSubLot')!.value;
    newVehicle.userName = this._appGeneralState.userName;
    newVehicle.emailAddress = this.parkerDetail.emailAddress;
    newVehicle.firstName = this.parkerDetail.firstName;
    newVehicle.lastName = this.parkerDetail.lastName;

    this.GetNumberOfAdditionalVehiclesForParker(this.parkerDetail.parkerId, newVehicle);
  }

  GetNumberOfAdditionalVehiclesForParker(parkerId: string, vehicleData: IAdditionalVehicles): void {
    let numberOfAdditionalVehicles: number;

    this.dataService.GetNumberOfAddiitonalVehiclesForParker(parkerId).subscribe(
      (res) => {
        numberOfAdditionalVehicles = res;
      },
      (err: any) => {},
      () => {
        if (numberOfAdditionalVehicles >= 9) {
          const dlgTitle: string = 'Unable to Add Additional Vehicle';
          const dlgLine1: string = 'Additional vehicle limit reached for this Parker.';
          const dlgLine2: string = 'You must remove an existing vehicle before adding a new vehicle.';
          let enterAnimationDuration: string = '0ms';
          let exitAnimationDuration: string = '0ms';

          const dialogRef = this.dialog.open(ErrorDialogStopComponent, {
            data: { dlgTitle: dlgTitle, dlgLine1: dlgLine1, dlgLine2: dlgLine2 },
            width: '450px',
            enterAnimationDuration,
            exitAnimationDuration,
          });
        } else {
          this.postAdditionalVehicle(vehicleData, this._appGeneralState.currentLotNumber);
        }
      },
    );
  }

  postAdditionalVehicle(vehicleData: IAdditionalVehicles, lotNumber: string): void {
    let additionalVehicleId: number;
    let newVehicle: IAdditionalVehicles;
    this.isProcessing = true;

    this.dataService.postAdditionalVehicleforParker(vehicleData, lotNumber).subscribe(
      (res) => {
        newVehicle = res;
      },
      (err: any) => {
        this.isProcessing = false;
        this._messageService.snackBarTopCenterTimed(
          'Error occurred during License Plate sync with spACE. Please try again.',
          5000,
        );
      },
      () => {
        vehicleData.vehicleId = newVehicle.vehicleId;
        this.isProcessing = false;

        // 20240806 :: Ken Moss Changed from appending new additional vehicle to array list to fetching list from db
        this.getAllAdditionalVehiclesForParker(this.parkerDetail.parkerId);

        this.parkerStateService.parkerNumberAdditionalVehicles = this.additionalVehicles.length;
        this.initVehicleForm();
        this._messageService.snackBarTopCenterTimed('This Vehicle has been successfully saved.', 5000);
        this.evaluateCredentialsNeeded(vehicleData.vehicleId);
      },
    );
  }

  evaluateCredentialsNeeded(vehcicleId: number): boolean {
    // Implement the logic to evaluate if credentials are needed for the given vehicle ID
    // Return true if credentials are needed, false otherwise
    // STUB: if this vehicle belongs to a Flash PARCS enabled lot, surface a placeholder
    // alert directing the user to go get the credential info (real UX/flow TBD).
    if (this._appGeneralState.isParcsFlash) {
      window.alert('Get the credential information here');
    }

    return false;
  }

  keyPressAlphanumeric(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActiveRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }

  onDeleteVehicle(vehicleId: number): void {
    const dialogRef = this.dialog.open(DialogConfirmDeleteComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deleteAdditionalVehicle(vehicleId);
    });
  }

  deleteAdditionalVehicle(vehicleId: number) {
    let status: boolean;
    this.isProcessing = true;
    this.dataService.deleteAdditionalVehicleforParker(vehicleId, this._appGeneralState.userName).subscribe(
      (res) => {
        status = res;
      },
      (err: any) => {
        this.isProcessing = false;
      },
      () => {
        this.isProcessing = false;
        let action: any;
        this.snackBar.open('This vehicle has been successfully deleted.', action, {
          duration: 3000,
        });

        this.currentVehicleEditIndex = -1;
        this.additionalVehicleSaveMode = false;

        // const arrayIndex = this.additionalVehicles.findIndex((vehicle) => vehicle.vehicleId == vehicleId);

        // if (arrayIndex != -1) {
        //   this.additionalVehicles.splice(arrayIndex, 1);

        //   this.parkerStateService.parkerNumberAdditionalVehicles = this.additionalVehicles.length;
        // }

        this.getAllAdditionalVehiclesForParker(this.parkerDetail.parkerId);
      },
    );
  }

  getAllAdditionalVehiclesForParker(parkerId: string): void {
    this.dataService.getAdditionalVehiclesForParker(parkerId).subscribe(
      (res) => {
        this.additionalVehicles = res;
      },
      (err: any) => {},
      () => {
        this.parkerStateService.parkerNumberAdditionalVehicles = this.additionalVehicles.length;
      },
    );
  }

  onPasteAlphanumericNewVehicle(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    // Remove all non-alphanumeric characters
    const sanitizedText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
    // Update the form control with sanitized value
    this.vehicleForm.patchValue({
      vehicleLicense: sanitizedText.substring(0, 16), // Respect maxlength
    });
  }

  onPasteAlphanumericUpdateVehicle(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    // Remove all non-alphanumeric characters
    const sanitizedText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
    // Update the form control with sanitized value
    this.vehicleEditForm.patchValue({
      vehicleLicense: sanitizedText.substring(0, 16), // Respect maxlength
    });
  }
}
